// extracted by mini-css-extract-plugin
module.exports = {"details":"a10a3f92e9--details--d_a2X","details-item":"a10a3f92e9--details-item--TMq_r","details-item__label":"a10a3f92e9--details-item__label--MyWUf"};